import React, { ReactElement } from 'react';
import { ApolloError } from '@apollo/client';
import { Modal } from '@odin-labs/components';
import {
  GetScheduleDetailsDocument,
  useDeleteScheduleWorkerMutation,
} from 'apollo/generated/client-operations';
import { getGraphQLError } from 'utils/error';
import { ScheduleWorker } from 'containers/jobsite/tabs/jobsiteSchedules/data/types';
import { AlertService } from 'components/alertService';
import { TrashIcon } from 'components/icons';
import { getOrganizationName } from 'utils';

export function DeleteScheduleWorkerModal(props: {
  isOpen: boolean;
  closeModal: () => void;
  onClosed?: () => void;
  scheduledWorker: ScheduleWorker;
}): ReactElement {
  const { isOpen, closeModal, scheduledWorker, onClosed } = props;
  const { quantity, jobsiteContractor } = scheduledWorker ?? {};
  const contractorName = getOrganizationName(
    jobsiteContractor?.contractor.organization,
  );

  const [deleteScheduleWorker, { loading }] = useDeleteScheduleWorkerMutation({
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      closeModal();
      AlertService.alert(
        'success',
        'Success',
        'Schedule worker deleted successfully',
      );
    },
    onError: (responseError: ApolloError) => {
      AlertService.alert(
        'danger',
        'Something went wrong!',
        getGraphQLError(responseError),
      );
    },
    variables: { id: scheduledWorker?.id },
    refetchQueries: [GetScheduleDetailsDocument],
  });

  return (
    <Modal
      actionButtonTheme="danger"
      actionButtonWithSpinner={loading}
      actionIcon={TrashIcon}
      actionText="Confirm"
      onAction={deleteScheduleWorker}
      open={isOpen}
      setOpen={closeModal}
      afterLeave={onClosed}
      size="xs"
      textAlignment="center"
      title={`Are you sure you want to remove the ${
        quantity > 1 ? `${quantity} workers` : 'worker'
      } scheduled for ${contractorName}?`}
      titleAlignment="center"
    />
  );
}
